/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import React from "react";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";

export default function Footer({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { director, creator, chiefAccountant } = formField;

  return (
    <Box mt={5}>
      <Grid container spacing={3}>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            label={creator.label}
            name={creator.name}
            value={values.creator}
            error={errors.creator && touched.creator}
            success={values.creator?.toString().length > 0 && !errors.creator}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            label={chiefAccountant.label}
            name={chiefAccountant.name}
            value={values.chiefAccountant}
            error={errors.chiefAccountant && touched.chiefAccountant}
            success={values.chiefAccountant?.toString().length > 0 && !errors.chiefAccountant}
          />
        </Grid>
      </Grid>

      <Grid container spacing={1}>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            label={director.label}
            name={director.name}
            value={values.director}
            error={errors.director && touched.director}
            success={values.director?.toString().length > 0 && !errors.director}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
